// Make all buttons in group same width based on largest width
class setMinWidth {
    constructor() {
        this.buttonGroups = document.querySelectorAll('[data-button-widths]')
        this.body = document.getElementById('body')
        if (this.buttonGroups.length > 0) {
            this.init();
        }
    }

    init() {
        this.buttonGroups.forEach((buttonGroup) => {
            let maxWidth = 0;
            buttonGroup.style.setProperty('--button-width-min', '50px')
            const buttons = buttonGroup.querySelectorAll('a')
            buttons.forEach((button) => {
                maxWidth = Math.max(maxWidth, button.offsetWidth);
            })
            buttonGroup.style.setProperty('--button-width-min', maxWidth + 1 + 'px')
        });
    }
}
export default setMinWidth;